<template>
  <div class="main">
    <div id="map" class="map"></div>
    <div id="dotsDetail" style="display: none;">
      <div class="dotDetaill">
        <div class="title">
          <span id="name">{{dotsDetail.monitorStation_Name}}</span>
        </div>
        <div class="detail">
          <div class="el">
            <span>更新时间：</span>
            <span>{{dotsDetail.time}}</span>
          </div>
          <div class="el" v-for="(item,index) in typeList" :key="index">
            <span v-html="item.ename"></span>
            <span>(</span>
            <span v-html="item.unit"></span>
            <span>)</span>
            <span :style="{'color':dotsDetail[item.name +'Color']}">{{dotsDetail[item.name]}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dateformat from "../../utils/dateformat.js";

export default {
  data() {
    return {
      userConfig: {},
      map: null,
      typeList: [],
      monitorStationId: 243,
      monitorStationName: "",
      dotsDetail: {},
      stationData: [],
      pmStationsData: [],
      sensorType: "",
      markers: [],
      pmStationsMarkers: [],
      sensorValueColor: [],
      districtId: -1,
      monitorAreaTypeId: -1,
      specialMarker: [
        {
          name: '南通大学附属中学',
          lnglat: [120.905868, 31.978631],
        },
        {
          name: '南通市第二中学',
          lnglat: [120.817949, 32.072239],
        },
        {
          name: '南通田家炳中学',
          lnglat: [120.861366, 31.989997],
        },
        {
          name: '江苏省通州高级中学',
          lnglat: [121.065993, 32.014393],
        },
        {
          name: '江苏省如皋中等专业学校',
          lnglat: [120.58345, 32.39163],
        },
        {
          name: '江苏省如东中等专业学校',
          lnglat: [121.186448, 32.349605],
        },
        {
          name: '江苏省南通中学',
          lnglat: [120.864232, 32.020919],
        },
        {
          name: '南通市通州区金沙中学',
          lnglat: [121.07199, 32.098068],
        },
        {
          name: '江苏省通州中等专业学校',
          lnglat: [121.077002, 32.095234],
        },
        {
          name: '江苏省海安高级中学',
          lnglat: [120.462483, 32.549159],
        },
        {
          name: '海安市实验中学',
          lnglat: [120.45398, 32.544613],
        },
        {
          name: '江苏省如东高级中学',
          lnglat: [121.174636, 32.293561],
        },
        {
          name: '江苏省启东中学',
          lnglat: [121.619968, 31.824991],
        },
        {
          name: '启东市汇龙中学',
          lnglat: [121.680658, 31.809849],
        },
        {
          name: '江苏省如皋中学',
          lnglat: [120.583217, 32.390038],
        },
        {
          name: '江苏省白蒲高级中学',
          lnglat: [120.763989, 32.235608],
        },
        {
          name: '江苏省江安高级中学',
          lnglat: [120.412344, 32.170567],
        },
        {
          name: '如皋市第一中学',
          lnglat: [120.572115, 32.385873],
        },
        {
          name: '江苏省海门中学',
          lnglat: [121.177222, 31.896484],
        },
        {
          name: '江苏省海门实验学校',
          lnglat: [121.183494, 31.88292],
        },
        {
          name: '海门市第一中学',
          lnglat: [121.183571, 31.888973],
        },
      ]
    };
  },
  methods: {
    addSpecialMarkers() {
      var content
      for(var i=0;i<this.specialMarker.length;i++){
        content='<div class="specialMarker"><img src="static/imgs/red_icon.png"><span>'+this.specialMarker[i].name+'</span></div>';
        var marker = new AMap.Marker({
          position:this.specialMarker[i].lnglat,   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: this.specialMarker[i].name,
          content:content
      });
      this.map.add(marker)
      }
      
    },
    initMap() {
      this.$set(
        this,
        "map",
        new AMap.Map("map", {
          resizeEnable: true,
          expandZoomRange: true,
          zoom: 10,
          zooms: [10, 20],
          center: ["120.978065", "31.943424"],
          mapStyle: "amap://styles/7315dda0f3072b4662c7fb598587cc2c"
        })
      );
      this.map.on("zoomchange", this.mapzoomchange);
      this.searchDistrict();
      this.getType();
      // this.addSpecialMarkers()
    },

    searchDistrict() {
      let $ele = this;
      AMap.service("AMap.DistrictSearch", () => {
        let opts = {
          subdistrict: 1,
          extensions: "all",
          level: "district"
        };
        $ele.district = new AMap.DistrictSearch(opts);
        $ele.district.setLevel("district");
        $ele.district.search("南通市", function(status, result) {
          let bounds = result.districtList[0].boundaries;
          let polygons = [];
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              let polygon = new AMap.Polygon({
                map: $ele.map,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0,
                fillColor: "#07101d",
                strokeColor: "#0bfcd7"
              });
              polygons.push(polygon);
            }
          }
        });
      });
    },

    // 初始化类型
    getType() {
      this.$http
        .get(
          this.userConfig.apiName +
            "/v4/" +
            this.userConfig.differentApi.sensorType
        )
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            if (result) {
              this.$set(this, "sensorType", result[0].name);
              this.$set(this, "typeList", result);
              this.getSensorValueColor();
            }
          }
        });
    },

    getSensorValueColor() {
      this.$http
        .get(this.userConfig.apiName + "/v4/sensorValueColor")
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            this.$set(this, "sensorValueColor", result);
            this.getMapMonitorStation();
          }
        });
    },
    getBgColorFromValue(curValue, curName, sensorValueColor) {
      let bgcolor = "";
      if (curValue * 1 > 0) {
        sensorValueColor.forEach(item => {
          if (item.sensor == curName) {
            item.valueColors.forEach(el => {
              if (bgcolor == "") {
                if (el.max == "") {
                  if (curValue * 1 > el.min * 1 || curValue * 1 == el.min * 1) {
                    bgcolor = el.color;
                  }
                } else {
                  if (
                    (curValue * 1 > el.min * 1 || curValue * 1 == el.min * 1) &&
                    curValue * 1 < el.max * 1
                  ) {
                    bgcolor = el.color;
                  }
                }
              }
            });
          }
        });
      } else {
        bgcolor = "#c4c4c4";
      }
      return bgcolor;
    },

    getMapMonitorStation() {
      let params = {
        sensorType: this.sensorType,
        timeType: 1
      };
      if (this.userConfig.platform == "shenyang") {
        params = {
          sensorType: this.sensorType,
          timeType: 1,
          districtId: this.districtId,
          monitorAreaTypeId: this.monitorAreaTypeId
        };
      }
      this.$http
        .get(this.userConfig.apiName + "/v4/mapMonitorStation", {
          params: params
        })
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            this.$set(this, "stationData", result);
            this.map.remove(this.markers);
            let level = this.map.getZoom();
            if (this.stationData.length > 0) {
              // this.setMarkerCenter(this.stationData);
              this.setMapMonitorStation(this.stationData, level);
            }
          }
        });
    },

    getPmStations() {
      this.$http
        .get(this.userConfig.apiName + "/v4/pmStations")
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            this.$set(this, "pmStationsData", result);
            let level = this.map.getZoom();
            this.setPmStationsData(this.pmStationsData, level);
          }
        });
    },

    setMapMonitorStation(stationData, level) {
      this.markers = [];
      for (let i = 0; i < stationData.length; i++) {
        let bgcolor = stationData[i].color;
        let value = stationData[i].value == 0 ? "-" : stationData[i].value;
        let content =
          "<div class='map_marker' style='background: url(../static/imgs/map/" +
          bgcolor.split("#")[1] +
          ".png)'>" +
          value +
          "</div>";
        if (level < 13) {
          content =
            "<div class='map_marker_circle' style='background: " +
            bgcolor +
            "'></div>";
        }
        let marker = new AMap.Marker({
          map: this.map,
          position: [stationData[i].longitude, stationData[i].latitude],
          content: content
        });
        marker.extData = {
          potData: stationData[i]
        };
        this.markers.push(marker);
        marker.on("mouseover", this.stationMarkerClickHandler);
        marker.on("click", this.toPage);
      }
    },

    setPmStationsData(pmStationsData, level) {
      this.pmStationsMarkers = [];
      for (let i = 0; i < pmStationsData.length; i++) {
        let data = pmStationsData[i];
        let type = this.sensorType;
        let bgcolor = this.getBgColorFromValue(
          pmStationsData[i].type,
          type,
          this.sensorValueColor
        );
        if (type == "tsp") {
          this.map.remove(this.pmStationsMarkers);
          return;
        }
        let value = data[type] == 0 ? "-" : data[type];
        let content =
          "<div class='pmstaion_marker' style='background: url(../static/imgs/map/pmStation_" +
          bgcolor.split("#")[1] +
          ".png)'>" +
          value +
          "</div>";
        if (level < 13) {
          content =
            "<div class='map_marker_circle style='background: " +
            bgcolor +
            "'></div>";
        }
        let marker = new AMap.Marker({
          map: this.map,
          position: [pmStationsData[i].longitude, pmStationsData[i].latitude],
          content: content
        });
        // 点位点击获取详情
        marker.extData = {
          potData: pmStationsData[i]
        };
        this.pmStationsMarkers.push(marker);
        marker.on("click", this.pmStationMarkerClickHandler);
      }
    },

    setMarkerCenter(stationData) {
      let lngSum = 0;
      let latSum = 0;
      for (let i = 0; i < stationData.length; i++) {
        let lng = stationData[i].longitude * 1;
        let lat = stationData[i].latitude * 1;
        lngSum += lng;
        latSum += lat;
      }
      let lngCenter = lngSum / stationData.length;
      let latCenter = latSum / stationData.length;
      this.map.setCenter([lngCenter + "", latCenter + ""]);
    },

    stationMarkerClickHandler(e) {
      let potData = e.target.extData.potData;
      this.$set(this, "monitorStationId", potData.monitorStationId);
      this.$set(this, "monitorStationName", potData.monitorStation_Name);
      this.$root.monitorStationHub.$emit(
        "monitorStation",
        this.monitorStationId,
        this.monitorStationName
      );
      this.$http
        .get(
          this.userConfig.apiName +
            "/v4/monitorStations/" +
            this.monitorStationId +
            "/latestHourSamples"
        )
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            result["time"] = Dateformat.format(
              result["time"],
              "yyyy-MM-dd hh:mm:ss"
            );
            this.$set(this, "dotsDetail", result);
            console.log(this.dotsDetail);
            this.$set(
              this.dotsDetail,
              "monitorStation_Name",
              potData.monitorStation_Name
            );
            setTimeout(() => {
              let content = document.getElementById("dotsDetail").innerHTML;
              let infoWindow = new AMap.InfoWindow({
                offset: new AMap.Pixel(10, -33)
              });

              infoWindow.setContent(content);
              infoWindow.open(this.map, e.target.getPosition());
            }, 0);
          }
        });
    },

    pmStationMarkerClickHandler(e) {
      let potData = e.target.extData.potData;
      potData["time"] = Dateformat.format(
        potData["time"],
        "yyyy-MM-dd hh:mm:ss"
      );
      this.$set(this, "potData", potData);
      this.$set(this.dotsDetail, "monitorStation_Name", potData.position_name);
      setTimeout(() => {
        let content = document.getElementById("dotsDetail").innerHTML;
        let infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(10, -33)
        });

        infoWindow.setContent(content);
        infoWindow.open(this.map, e.target.getPosition());
      }, 0);
    },

    mapzoomchange() {
      let level = this.map.getZoom();
      this.map.remove(this.markers);
      this.setMapMonitorStation(this.stationData, level);
    },
    //跳转到历史数据
    toPage(e) {
      let potData = e.target.extData.potData;
      // this.$set(this, "monitorStationId", potData.monitorStationId);
      window.sessionStorage.setItem("monitorId", potData.monitorStationId);
      this.$router.push("/detail/history");
    }
  },
  mounted() {
    this.$set(
      this,
      "userConfig",
      JSON.parse(window.sessionStorage.getItem("userConfig"))
    );
    if (this.userConfig) {
      this.initMap();
      this.$root.sensorTypeHub.$on("sensorType", sensorType => {
        this.$set(this, "sensorType", sensorType);
        this.map.remove(this.markers);
        this.getMapMonitorStation();
      });
      this.$root.selectModelHub.$off("select");
      this.$root.selectModelHub.$on("select", (districts, industry) => {
        this.$set(this, "districtId", districts);
        this.$set(this, "monitorAreaTypeId", industry);
        this.map.remove(this.markers);
        this.getMapMonitorStation();
      });
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="less">
.specialMarker{
  padding: 5px 2px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: 25px;
    height: 25px;
  }
}
.map {
  .hoverTitle {
    background: #003366;
    border: 0px;
  }
  .amap-info-content {
    overflow: inherit;
    border: 0px;
    box-shadow: none;
    background: transparent;
    padding: 0px;
    border-radius: 10px;
  }
  .amap-info-sharp {
    background-image: url(../../../static/imgs/sharp.png);
  }
  .amap-info-close {
    top: 5px;
    color: #fff;
  }
  .map_marker {
    font-size: 0.16rem;
    color: #fff;
    background-repeat: no-repeat;
    width: 47px;
    height: 38px;
    line-height: 30px;
    text-align: center;
  }
  .pmstaion_marker {
    font-size: 0.16rem;
    color: #fff;
    background-repeat: no-repeat;
    width: 59px;
    height: 52px;
    line-height: 60px;
    text-indent: 0.25rem;
    text-align: left;
  }
  .map_marker_circle {
    width: 10px;
    height: 10px;
    border-radius: 100%;
  }
}
</style>

<style scoped lang="less">
.map {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.dotDetaill {
  border-radius: 10px;
  z-index: 1;
  overflow: hidden;
  background: transparent;
  border: 1px solid #034c26;
  .el {
    padding-bottom: 0.07rem;
  }

  .title {
    color: #fff;
    font-size: 16px;
    text-align: center;
    border-bottom: 1px solid #034c26;
    background: #081521;
    opacity: 1;
    padding: 10px 0px;
    padding-top: 20px;
  }

  .time {
    padding-right: 0.1rem;
    font-size: 12px;
    background: #081521;
    opacity: 1;
    padding: 0.08rem 0.1rem;
    color: #fff;
  }

  .detail {
    font-size: 13px;
    background: #081521;
    opacity: 1;
    color: #fff;
    padding: 10px;
    .elBtn {
      padding-bottom: 0.07rem;
      text-align: right;

      button {
        border: 1px solid #0bfcd7;
        border-radius: 4px;
        color: #0bfcd7;
        background: transparent;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/map.vue